<template>
  <nuxt-link
    :class="[{ selected: selected }, theme]"
    :to="to"
    :replace="true"
    class="button-nav"
  >
    <span class="label"><slot /></span>
  </nuxt-link>
</template>

<script lang="ts" setup>
interface Props {
  index: number;
  theme: 'default' | 'sub';
  type: 'nav' | 'subNav';
  slug: string;
}
const props = defineProps({
  index: null,
  theme: null,
  type: null,
  slug: null
});

const { categorySlug, contentSlug, childSlug } = useModalCategoryRouter();

const to = computed(() => {
  if (props.type === 'nav') {
    return `#/modal/${categorySlug.value}/${props.slug}`;
  } else {
    return `#/modal/${categorySlug.value}/${contentSlug.value}/${props.slug}`;
  }
});

const selected = computed(() => {
  if (props.type === 'nav') {
    if (contentSlug.value === '') return props.index === 0;
    return contentSlug.value === props.slug;
  } else {
    if (childSlug.value === '') return props.index === 0;
    return childSlug.value === props.slug;
  }
});
</script>

<style lang="scss" scoped>
.button-nav {
  @include font('n', 700);

  display: flex;
  position: relative;
  flex-grow: 0;
  align-items: center;
  justify-content: flex-start;
  min-width: 4rem;
  max-width: 16rem;
  height: 3rem;
  padding: 1rem 2rem;
  overflow: hidden;
  color: var(--color_neutral_100);
  gap: 0.6rem;
  &.sub {
    color: var(--color_neutral_700);
  }
  .label {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    hyphens: auto;
  }
  &.selected {
    border: 0.1rem solid var(--color_neutral_50);
    border-radius: 4rem;
    background-color: var(--color_neutral_50);
    box-shadow: rgb(0 0 0 / 16%) 0 1px 4px;
    color: var(--color_secondary);
    &.sub {
      background-color: var(--color_neutral_50);
      box-shadow: rgb(0 0 0 / 16%) 0 1px 4px;
      color: var(--color_secondary);
    }
  }
  @include above('l') {
    max-width: 50rem;

    // height: 5rem;
    // padding: 1rem 2rem;
  }
}
</style>
